import { Link, useLocation } from "react-router-dom";
import { Home, BookOpen, Printer, PlayCircle, Gamepad2 } from "lucide-react";

const items = [
  { label: "Home", path: "/", Icon: Home },
  { label: "Stories", path: "/stories", Icon: BookOpen },
  { label: "Printables", path: "/printables", Icon: Printer },
  { label: "Videos", path: "/yt-gallery", Icon: PlayCircle },
  { label: "Games", path: "/games", Icon: Gamepad2 },
];

const MobileBottomNav = () => {
  const location = useLocation();
  return (
    <nav
      className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md border-t border-cyan-200 shadow-[0_-4px_20px_-8px_rgba(6,182,212,0.25)] pb-[env(safe-area-inset-bottom)]"
      aria-label="Primary mobile navigation"
    >
      <ul className="flex items-stretch justify-around px-1 py-1.5">
        {items.map(({ label, path, Icon }) => {
          const active = location.pathname === path;
          return (
            <li key={path} className="flex-1">
              <Link
                to={path}
                className={`flex flex-col items-center justify-center gap-0.5 py-1.5 rounded-xl transition-all ${
                  active
                    ? "bg-cyan-100 text-cyan-700"
                    : "text-gray-500 hover:text-cyan-600"
                }`}
              >
                <Icon className={`w-5 h-5 ${active ? "scale-110" : ""}`} strokeWidth={active ? 2.5 : 2} />
                <span className="font-fredoka text-[11px] font-semibold leading-none">{label}</span>
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default MobileBottomNav;
